import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'canvas-admin-table-layout-panel',
  templateUrl: './table-layout.panel.component.html',
  styleUrls: ['./table-layout.panel.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableLayoutPanelComponent {}
